import React from "react";
import { Box, Typography } from "@mui/material";
import { getIcon } from "@dishopsaas/design-system";
import { getOrderTypeLabel } from "../../../utils";
import { ORDER_TYPE_CLICK_AND_SEAT, ORDER_TYPE_ICONS } from "../../../constants";
import getStyles from "../Order.styles";
export default function renderOrderType(orderType = ORDER_TYPE_CLICK_AND_SEAT, isBold?: boolean, size?: number, variant?: any) {
  const label = getOrderTypeLabel(orderType);
  const iconKey = ORDER_TYPE_ICONS[orderType];
  const styles = getStyles()
  return (
    <Box sx={styles.orderTypeStyle}>
      {getIcon(iconKey, { size: size || isBold ? 20 : 12 })}
      <Typography variant={variant ? variant : (isBold ? "h5" : "body1")} sx={{ width: 'max-content' }}>{label}</Typography>
    </Box>
  );
}
